<template>
  <div>
    <el-row>
      <div style="float: left; margin: 10px 0px 10px 0px;">
        <label style="display: block; font-size: 12px; margin: 0px 0px 5px 0px;">Group Data By:</label>
        <el-select :default-first-option="true" style="width: 170px" v-model="localPendingGrouping" @input="localPendingDrillDown = ''" placeholder="Group Data by" filterable
          @change="setVuexState">
          <el-option v-for="item in pendingReasonDropdown" :key="item.key" :label="item.value" :value="item.key">
          </el-option>
        </el-select>
      </div>
      <div style="float: left; margin: 10px 0px 10px 10px;">
        <label style="display: block; font-size: 12px; margin: 0px 0px 5px 0px;">Drilldown:</label>
        <el-select :default-first-option="true" style="width: 170px" v-model="localPendingDrillDown" placeholder="Drilldown" filterable clearable @change="setVuexState">
          <el-option v-for="item in pendingReasonDropdown.filter(x => x.key !== localPendingGrouping)" :key="item.key" :label="item.value" :value="item.key">
          </el-option>
        </el-select>
      </div>
      <div style="float:right; margin-right: 10px;">
        <el-switch style="display: block; margin-top: 5px;" @change="refreshData()" v-model="currentlyPending" active-color="#13ce66" inactive-color="#ff4949"
          active-text="Live" inactive-text="Historical">
        </el-switch>
      </div>
    </el-row>

    <el-table id="codingLargeStat10" v-loading="loading" element-loading-spinner="nucleus-loader" :data="getPendingReasonData()" empty-text="No Pending Data Available"
      :fit="true" :height="isModal ? null : '382'" show-summary :summary-method="getSummary">
      <el-table-column prop="title" label="Grouping" id="headerTitle" sortable show-overflow-tooltip>
      </el-table-column>
      <el-table-column type="expand" id="headerExpand">
        <template slot-scope="props">
          <el-table id="pendingDrillDownTable" :data="getDrillDownForRow(props.row, localPendingDrillDown)" empty-text="No Drilldown Selected" :fit="true">
            <el-table-column prop="title" id="subTitle" show-overflow-tooltip min-width="100">
            </el-table-column>
            <el-table-column prop="totalCharges" align="left" :formatter="moneyFormatter">
            </el-table-column>
            <el-table-column prop="total" align="center">
              <template slot-scope="scope">
                <div class=" dottedUnderline" ref="" @click="emitDetailsEvent(`${props.row.title}-${scope.row.title} Records`, scope.row.accounts, $event)">
                  {{scope.row.total}}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column label="Charges" prop="totalCharges" align="left" :formatter="moneyFormatter">
      </el-table-column>
      <el-table-column label="Total Records" prop="total" align="center">
        <template slot-scope="scope">
          <div class="dottedUnderline" ref="" @click="emitDetailsEvent(`${scope.row.title} Records`, scope.row.accounts, $event)">
            {{scope.row.total}}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div style="font-size: 15px; position: absolute; bottom: 5px;">
      {{dashboardData.length ? dashboardData[0].largeStats[3].footer : ''}}
    </div>
  </div>
</template>

<script>
  import money from '@/mixins/money'
  import { mapState, mapMutations, mapActions } from 'vuex'

  export default {
    props: ['dashboardData'],
    mixins: [money],
    components: {
    },
    data: function () {
      return {
        currentlyPending: true,
        loading: false,
        localPendingGrouping: 'Category',
        localPendingDrillDown: 'Physician',
        pendingReasonDropdown: [{ key: 'Category', value: 'Pending Reason' }, { key: 'CDI Staff', value: 'CDI Staff' }, { key: 'Consultant', value: 'Consultant' }, { key: 'Physician', value: 'Physician' }, { key: 'Service', value: 'Service' }]
      }
    },
    name: 'PendingReasonsTable',
    methods: {
      ...mapActions('dashboard', ['GET_PENDINGLIST_STATISTICS']),
      ...mapMutations('dashboard', ['SET_PENDING_LIST_FIELDS', 'SET_CURRENTLY_PENDING']),
      refreshData() {
        this.SET_CURRENTLY_PENDING(this.currentlyPending)
        const payload = {
          currentClient: this.currentClient,
          startDate: this.codingDateRange[0],
          endDate: this.codingDateRange[1],
          currentlyPending: this.currentlyPending
        }
        this.loading = true
        this.GET_PENDINGLIST_STATISTICS(payload).then(() => {
          this.loading = false
        })
      },
      patientTypeGetDrillDownForRow(row) {
        return row.consultants.length ? row.consultants : []
      },
      moneyFormatter(row, column) {
        return `$${this.formatMoney(row.totalCharges || row.consultantTotalCharges)}`
      },
      getPendingReasonData() {
        switch (this.localPendingGrouping) {
          case 'Category':
            return this.dashboardData.length ? this.dashboardData[0].largeStats[10].data : []
          case 'Physician':
            return this.dashboardData.length ? this.dashboardData[0].largeStats[11].data : []
          case 'CDI Staff':
            return this.dashboardData.length ? this.dashboardData[0].largeStats[12].data : []
          case 'Service':
            return this.dashboardData.length ? this.dashboardData[0].largeStats[13].data : []
          case 'Consultant':
            return this.dashboardData.length ? this.dashboardData[0].largeStats[14].data : []
        }
      },
      getDrillDownForRow(row, type) {
        switch (type) {
          case 'Category':
            return row.categories
          case 'Physician':
            return row.physicians
          case 'CDI Staff':
            return row.cdiStaff
          case 'Service':
            return row.service
          case 'Consultant':
            return row.consultants
        }
      },
      emitDetailsEvent(title, accounts, e) {
        this.$emit('detailsClick', {
          title: title,
          accounts: accounts,
          e: e
        })
      },
      setVuexState() {
        if (!this.isModal) {
          this.SET_PENDING_LIST_FIELDS({ pendingGrouping: this.localPendingGrouping, pendingDrillDown: this.localPendingDrillDown })
        }
      },
      totalSummary(column, data) {
        let response = data.reduce((total, curr) => {
          const value = Number(curr[column])
          if (!isNaN(value)) {
            return total + value
          } else {
            return total
          }
        }, 0)

        return response
      },
      getSummary(param) {
        const totalCharges = this.totalSummary('totalCharges', param.data)
        const total = this.totalSummary('total', param.data)

        return [null, null, `$${this.formatMoney(totalCharges)}`, total]
      }
    },
    created: function () {
      if (this.isModal) {
        this.localPendingGrouping = this.pendingGrouping
        this.localPendingDrillDown = this.pendingDrillDown
      }
    },
    mounted: function () {
      this.$nextTick(() => {
        const footerRow = document.querySelectorAll('#codingLargeStat10 table.el-table__footer td')
        const td = footerRow[footerRow.length - 1]
        td.classList.add('dottedUnderline')
        td.addEventListener('click', (e) => {
          const allAccounts = this.dashboardData[0].largeStats[10].data.map(x => x.accounts).join(',')
          this.emitDetailsEvent('All Pending Records', allAccounts, e)
        })
      })
    },
    computed: {
      ...mapState('dashboard/', ['pendingDrillDown', 'pendingGrouping', 'codingDateRange']),
      ...mapState('user/', ['currentClient', 'currentClientId']),
      isModal() {
        return this.$parent.modal
      }
    },
    watch: {
      pendingGrouping: function () {
        if (this.isModal) {
          this.localPendingGrouping = this.pendingGrouping
        }
      },
      pendingDrillDown: function () {
        if (this.isModal) {
          this.localPendingDrillDown = this.pendingDrillDown
        }
      }
    }
  }
</script>

<style scoped>
  >>>.el-switch__label * {
    font-size: 12px !important;
    font-weight: 400 !important;
  }
</style>
